import Control from "../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROCulture = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });

  const activityKey = "culture";

  return (
    <div>
      <Control
        label={inputsConfig.cultureOrganisationEvenements.label}
        type="btnList"
        name="cultureOrganisationEvenements"
        value={company.RCPRO.cultureOrganisationEvenements}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.cultureOrganisationEvenements.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      {company.RCPRO.cultureOrganisationEvenements == 1 && (
        <Control
          label={inputsConfig.cultureAssuranceEvenements.label}
          type="btnList"
          name="cultureAssuranceEvenements"
          value={company.RCPRO.cultureAssuranceEvenements}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          btnInline
          datas={inputsConfig.cultureAssuranceEvenements.datas}
          dataIndex="id"
          dataLabel="name"
          onBlur={onBlur}
          required
        />
      )}
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROCulture;
